import * as Types from './assessmentsActionTypes';

export function getAssessments() {
  return { type: Types.GET_ASSESSMENTS };
}

export function getAssessmentsSuccess(assessments) {
  return { type: Types.GET_ASSESSMENTS_SUCCESS, assessments };
}

export function getAssessmentsFailure(error) {
  return { type: Types.GET_ASSESSMENTS_FAILURE, error };
}

export function getAssessment(id, updateCurrentAssessment = false, onFail = () => undefined) {
  return { type: Types.GET_ASSESSMENT, id, updateCurrentAssessment, onFail };
}

export function getAssessmentSuccess(assessment) {
  return { type: Types.GET_ASSESSMENT_SUCCESS, assessment };
}

export function getAssessmentFailure(error) {
  return { type: Types.GET_ASSESSMENT_FAILURE, error };
}

export function saveAnswer({ id, index, answer }) {
  return { type: Types.SAVE_CURRENT_ANSWER, id, index, answer };
}

export function saveNotes({ id, index, notes }) {
  return { type: Types.SAVE_NOTES, id, index, notes };
}

export function toggleFlag(id, index) {
  return { type: Types.TOGGLE_FLAG_CURRENT_ANSWER, id, index };
}

export function saveAssessmentInfo(data) {
  return { type: Types.SAVE_ASSESSMENT_INFO, data };
}

export function postAssessment(assessment) {
  return { type: Types.POST_ASSESSMENT, assessment };
}

export function putAssessment(assessment, complete = false, onFail = () => undefined, onSuccess = () => undefined) {
  return { type: Types.PUT_ASSESSMENT, assessment, complete, onFail, onSuccess };
}

export function splitPutAssessment(assessment, onSuccess, onFail) {
  return { type: Types.SPLIT_PUT_ASSESSMENT, assessment, onSuccess, onFail };
}

export function forcePutAssessment(assessment, onSuccess, onFail) {
  return { type: Types.FORCE_PUT_ASSESSMENT, assessment, onSuccess, onFail };
}

export function clearCurrentAssessment() {
  return { type: Types.CLEAR_CURRENT_ASSESSMENT };
}

export function updateCurrentAssessment(assessment) {
  return { type: Types.UPDATE_CURRENT_ASSESSMENT, assessment };
}

export function postAssessmentFailure(error) {
  return { type: Types.POST_ASSESSMENT_FAILURE, error };
}

export function putAssessmentFailure(error) {
  return { type: Types.PUT_ASSESSMENT_FAILURE, error };
}

export function navigateTo(page, questionIndex = null) {
  return { type: Types.NAVIGATE_TO, page, questionIndex };
}

export function selectSection(id, onFail) {
  return { type: Types.SELECT_SECTION, id, onFail };
}

export function uploadAssessment(assessment, onProgress) {
  return { type: Types.UPLOAD_ASSESSMENT, assessment, onProgress };
}

export function uploadAssessmentSuccess() {
  return { type: Types.UPLOAD_ASSESSMENT_SUCCESS };
}

export function uploadAssessmentFailure(error) {
  return { type: Types.UPLOAD_ASSESSMENT_FAILURE, error };
}

export function downloadComparison(assessmentIds, onSuccess) {
  return { type: Types.DOWNLOAD_COMPARISON, assessmentIds, onSuccess };
}

export function downloadComparisonSuccess() {
  return { type: Types.DOWNLOAD_COMPARISON_SUCCESS };
}

export function downloadComparisonFailure(error) {
  return { type: Types.DOWNLOAD_COMPARISON_FAILURE, error };
}

export function downloadAssessment(assessmentId, onSuccess) {
  return { type: Types.DOWNLOAD_ASSESSMENT, assessmentId, onSuccess };
}

export function downloadAssessmentSuccess(assessment) {
  return { type: Types.DOWNLOAD_ASSESSMENT_SUCCESS, assessment };
}

export function downloadAssessmentFailure(error) {
  return { type: Types.DOWNLOAD_ASSESSMENT_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/redux/actions/assessmentsActions.js